<app-header></app-header>
<app-sidebar></app-sidebar>

<div id="main-content">
    <div class="container-fluid">
        <!-- <div class="block-header">
            <div class="row">
                <div class="col-lg-5 col-md-8 col-sm-12">
                    <h2><a href="javascript:void(0);" class="btn btn-xs btn-link" (click)="backClicked()">
                            <i class="fa fa-arrow-left"></i>
                        </a> Blog Room Request
                    </h2>
                </div>
            </div>
        </div> -->
        <div class="block-header top-head-vt">
            <div class="row">
                <div class="col-lg-5 col-md-8 col-sm-12">
                    <ul class="breadcrumb vt-a">
                        <li class="breadcrumb-item"><a [routerLink]="['/dashboard']"><i class="icon-home"></i></a></li>
                        <li class="breadcrumb-item">Dealroom</li>
                        <li class="breadcrumb-item"><a routerLink="/dashboard">Blog Room Request</a></li>
                      </ul>
            
                </div>
            </div>
        </div>

        <div class="row clearfix">
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h2>Blog Room Request List</h2>
                        <!-- <a routerLink="/admin/dealroom/add" class="btn btn-primary color_cls">Create Blog Room</a> -->
                    </div>
                    <div class="body">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">User Name</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Requested Date</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody *ngIf="users?.length; else no_data_templ">
                                <tr *ngFor="let value of users; index as i">
                                    <th scope="row">{{ i + 1 }}</th>
                                    <td>
                                        {{ value.name }}
                                    </td>
                                    <td>
                                        {{ value.email }}
                                    </td>
                                    <td>
                                        {{ value.created_at | date:'dd-MM-yyyy' }}
                                    </td>
                                    <td>
                                        <button (click)="JoinUserToRoom(value.id,id)" class="btn btn-primary"
                                            ngbTooltip="Join User To Room">Confirm Joining</button>
                                    </td>
                                </tr>
                                <tr *ngIf="users.length==0">
                                    <td colspan="4">No Request Data Found</td>
                                </tr>
                            </tbody>
                            <ng-template #no_data_templ>
                                <tr>
                                    <td colspan="4" class="text-center">No Request Data Found</td>
                                </tr>
                            </ng-template>
                        </table>
                    </div>

                </div>
            </div>

        </div>


    </div>
</div>